import { Component, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { UiAppHeaderComponent, UiWhatsappFabComponent } from '@system-dyg/shared/ui';

const DEFAULT_HEADER_TITLE = 'Verificacion segura';
const DEFAULT_DOCUMENT_TITLE = 'Verificación segura | Diseño y Gestión';
const WHATSAPP_SUPPORT_HREF =
  'https://wa.me/523312554491?text=' +
  encodeURIComponent(
    'Hola. Tengo dudas respecto del funcionamiento de firma y validación digital. Puedes apoyarme',
  );

@Component({
  imports: [RouterOutlet, UiAppHeaderComponent, UiWhatsappFabComponent],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly router = inject(Router);
  private readonly documentTitle = inject(Title);

  protected readonly whatsappSupportHref = WHATSAPP_SUPPORT_HREF;

  protected readonly title = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.resolveHeaderTitle()),
      startWith(this.resolveHeaderTitle()),
    ),
    { initialValue: this.resolveHeaderTitle() },
  );

  protected readonly showHeader = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.resolveShowHeader()),
    ),
    { initialValue: false },
  );

  private readonly pageTitle = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.resolvePageTitle()),
      startWith(this.resolvePageTitle()),
    ),
    { initialValue: this.resolvePageTitle() },
  );

  constructor() {
    effect(() => {
      this.documentTitle.setTitle(this.pageTitle());
    });
  }

  private resolveHeaderTitle(): string {
    return this.resolveRouteData('headerTitle') ?? DEFAULT_HEADER_TITLE;
  }

  private resolvePageTitle(): string {
    return this.resolveRouteData('pageTitle') ?? DEFAULT_DOCUMENT_TITLE;
  }

  private resolveShowHeader(): boolean {
    return this.resolveRouteData('showHeader') !== false;
  }

  private resolveRouteData<T>(key: string): T | undefined {
    let route = this.router.routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    return route.snapshot.data[key] as T | undefined;
  }
}
